import React from 'react';

import * as Section from 'ha/ui.legacy/Section';
import { UserEntity } from 'ha/types/UserEntity';
import {
  UserCardProfile,
  UserCardVerification,
  UserCardReportBtn,
  UserCard,
} from 'ha/components.legacy/UserCard';
import { Divider } from '@hbf/dsl';

function shouldShowVerifications(user: UserEntity) {
  return (
    user.isEmailVerified ||
    user.hasPhone ||
    user.hasFacebookProfile ||
    user.hasPaymentMethod
  );
}

interface Props {
  user: UserEntity;
  showReportBtn: boolean;
}

export const UserCardLite: React.FC<Props> = ({
  user,
  children,
  showReportBtn,
}) => (
  <UserCard data-test-locator="UserCardLite">
    <UserCardProfile user={user} showDescription={false} linkToProfile />
    {children ? (
      <section>
        <Section.Text>{children}</Section.Text>
      </section>
    ) : null}
    {shouldShowVerifications(user) ? (
      <UserCardVerification user={user} />
    ) : null}
    <Divider />
    {showReportBtn ? (
      <UserCardReportBtn reportedUserID={user.entityId} />
    ) : null}
  </UserCard>
);
